import React from 'react';

const cssClass = (height) => {
  const sizes = {
    short: 'h-short',
    default: '',
  };

  return sizes[height || 'default'];
};

export default props => (
  <div className={`row form-footer ${cssClass(props.height)}`}>
    <div className="col-12"><hr /></div>
    {props.children}
  </div>
);



// WEBPACK FOOTER //
// ./src/desktop/components/form-footer.js